import Vue from "vue";


export function setI18nLanguage(lang) {
  Vue.prototype.$http.defaults.headers.common["Content-Language"] = lang.id;
  return lang;
}